import React, { Component } from "react";
import { Modal, Spin, message, Upload, Icon, Button } from "antd";
import { observer } from "mobx-react";

const Dragger = Upload.Dragger;

@observer
class ImportFilesDialog extends Component {
	uploadFiles = () => {
		//Do nothing
	};

	hideDialog = () => {
		this.props.hideDialog();
	};

	render() {
		const uploaderProps = {
			name: "file",
			multiple: this.props.multiple ? true : false,
			action: this.props.uploadUrl,
			onChange(info) {
				const status = info.file.status;
				if (status !== "uploading") {
					// console.log(info.file, info.fileList);
				}
				if (status === "done") {
					message.success(`${info.file.name} file uploaded successfully.`);
				} else if (status === "error") {
					message.error(`${info.file.name} file upload failed.`);
				}
			}
		};

		return (
			<Modal
				visible={this.props.dialogVisible}
				title={this.props.title}
				okText="Import"
				// onCancel={this.hideDialog}
				// onOk={this.uploadFile}
				closable={false}
				maskClosable={false}
				destroyOnClose={true}
				footer={[
					<Button key="close" type="primary" onClick={this.hideDialog}>
						Close
					</Button>
				]}
			>
				<Spin spinning={this.props.uploadingFiles == true}>
					<Dragger {...uploaderProps}>
						<p className="ant-upload-drag-icon">
							<Icon type="inbox" />
						</p>
						<p className="ant-upload-text">
							Click or drag file to this area to upload
						</p>
						<p className="ant-upload-hint">
							{this.props.hint}
						</p>
					</Dragger>
				</Spin>
			</Modal>
		);
	}
}

export default ImportFilesDialog;
